<template>
  <FormulateInput
    v-bind="{ ...$props, ...$attrs }"
    :validation-name="placeholder"
    :placeholder="elementPlaceholder"
  />
</template>

<script>
import Vue from 'vue';
import VueScreen from 'vue-screen';
import requiredLabelMixin from '../requiredLabelMixin';

Vue.use(VueScreen);

export default {
  name: 'SelectField',
  mixins: [requiredLabelMixin],
  props: {
    type: {
      type: String,
      default() {
        // Render a native select if we are on mobile
        return this.$screen.touch ? 'select' : 'multiselect';
      },
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    validation: {
      type: String,
      default: 'required',
    },
    inputClass: {
      type: String,
      default() {
        return this.$screen.touch ? 'form-select' : '';
      },
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    closeOnSelect: {
      type: Boolean,
      default() {
        return !this.multiple;
      },
    },
    inlineDropdown: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    normalizedValue() {
      if (!this.value) {
        return this.multiple ? [] : null;
      }
      return this.value;
    },
  },
};
</script>
